module.exports = __webpack_public_path__ + "media/images/MR_SwtcR-2fd91229.svg";